import { useAppSelector, useAppDispatch } from "@/services/hooks";
import React, { useState, useEffect } from "react";

// Select  settings / Content vars + required/ optioanl
import VariablesSelectByTypes from "@/components/dashboard/VariablesSelectByTypes";
import HandleRequired from "./HandleRequired";
import HandleOptional from "./HandleOptional";
// Actions
// Save the settings required to redux
import { saveSettingsRequired } from "@/services/templateServices/templateAction";
// Save settings optional to redux
import { saveSettingsOptional } from "@/services/templateServices/templateAction";
// Update template action
import { updateTemplate } from "@/services/templateServices/templateAction";
// select Input for template type
import Select from "react-select";


// reactstrap components
import {
  Col,
  Label,
  FormGroup,
  InputGroup,
  InputGroupText,
  Input,
  Row,
  Form,
} from "reactstrap";
// nodejs library that concatenates classes
import classnames from "classnames";
import NotificationAlertOptions from "@/layouts/Alerts";
import { asCaught } from "@/services/caughtError";

// Template types
const types = [
  { label: "Home Page", value: "home_page" },
  { label: "Category page", value: "intro_page" },
  { label: "Listing page", value: "listing_page" },
  { label: "Product details page", value: "product_details" },
  { label: "Contact page with a form", value: "contact_form" },
  { label: "Blog index", value: "blog_index" },
  { label: "blog page details", value: "blog_page" },
  { label: "Author page", value: "author_page" },
  { label: "info page", value: "info_article" },
  { label: "Redirection page", value: "redirect_page" },
  { label: "Error page", value: "error_page" },
  { label: "Sitemap", value: "sitemap_page" },
  { label: "How we score", value: "score_method_page" },
  { label: "Privacy page", value: "privacy_page" },
  { label: "Navigation Bar", value: "navigation" },
  { label: "Footer", value: "footer" },
      { label: "product simple", value: "product_simple" },


];

// The fields the template schema marks `required: true` and this screen can
// edit. Mirrors REQUIRED_TEMPLATE_FIELDS in server/controllers/template.js.
const REQUIRED_TEMPLATE_FIELDS = ["name", "type", "template_src"];

export type UpdateTemplateProps = {
  /** the template document as the list loaded it; the form edits it in place, untyped as before */
  template: any; // any: no client type for the template document yet; the form edits its fields by name
  switchToDesignListHandler: () => void | Promise<void>;
};

function UpdateTemplate(props: UpdateTemplateProps) {
  const dispatch = useAppDispatch();

  const settingsRequired = useAppSelector(
    (state) => state.templates.settings_required
  );

  const settingsOptional = useAppSelector(
    (state) => state.templates.settings_optional
  );

  const currentSite = useAppSelector(
    (state) => state.sites.site
  );

  const [template, setTemplate] = useState(props.template);

  useEffect(() => {
    if (currentSite){
      setTemplate({
        ...template,
        site: currentSite._id,
      });
    }
  }, [currentSite])

  useEffect(() => {
    if (settingsRequired.length === 0) {
      dispatch(
        saveSettingsRequired(template.settings_variables.SettingsRequired)
      );
    }

    if (settingsOptional.length === 0) {
      dispatch(
        saveSettingsOptional(template.settings_variables.SettingsOptional)
      );
    }

    if (
      settingsRequired.length ===
        template.settings_variables.SettingsRequired.length &&
      JSON.stringify(settingsRequired) !==
        JSON.stringify(template.settings_variables.SettingsRequired)
    ) {
      setTemplate({
        ...template,
        settings_variables: {
          ...template.settings_variables,
          SettingsRequired: [...settingsRequired],
        },
      });
    }

    if (
      settingsOptional.length ===
        template.settings_variables.SettingsOptional.length &&
      JSON.stringify(settingsOptional) !==
        JSON.stringify(template.settings_variables.SettingsOptional)
    ) {
      setTemplate({
        ...template,
        settings_variables: {
          ...template.settings_variables,
          SettingsOptional: [...settingsOptional],
        },
      });
    }

  }, [template, settingsRequired, settingsOptional]);

  // Change tempalte name handler
  const onChangeTemplateName = (e) => {
    setTemplate({ ...template, name: e.target.value });
  };

  // change template type handler
  const onChangeTemplateType = (e) => {
    if (e !== null) {
      setTemplate({ ...template, type: e.value });
    }
  };

  // change template path handler
  const onChangeTemplatePath = (e) => {
    setTemplate({ ...template, template_src: e.target.value });
  };

  // change tempalte settings variables
  const onChangeSettignsVariables = (value, status) => {

    // function that will let us keep the values of the variables if we change them
    function add(arr, elem) {
      const { length } = arr;
      const id = length + 1;
      const found = arr.some((el) => el._id === elem._id);
      if (!found) arr.push(elem);
      return arr;
    }
    switch (status) {
      case "required": {
        // When we remove variables
        const myArrayFilteredReuired =
          template.settings_variables.SettingsRequired.filter((el) => {
            return value.some((f) => {
              return f._id === el._id;
            });
          });

        // When we add new required settings variable
        const AddedRequired = value.map((val) =>
          add(myArrayFilteredReuired, val)
        );

        // Save settings required to redux
        dispatch(saveSettingsRequired(myArrayFilteredReuired));
        // Set the template state
        setTemplate({
          ...template,
          settings_variables: {
            ...template.settings_variables,
            SettingsRequired: myArrayFilteredReuired,
          },
        });
        break;
      }
      case "optional": {
        const myArrayFilteredOptional =
          template.settings_variables.SettingsOptional.filter((el) => {
            return value.some((f) => {
              return f._id === el._id;
            });
          });
        // when we add optional setting variable
        const AddedOptional = value.map((val) =>
          add(myArrayFilteredOptional, val)
        );
        // Save settings optional to redux
        dispatch(saveSettingsOptional(myArrayFilteredOptional));
        // Set the template state
        setTemplate({
          ...template,
          settings_variables: {
            ...template.settings_variables,
            SettingsOptional: myArrayFilteredOptional,
          },
        });
        break;
      }
      default:
        break;
    }
  };

  // change template content variables
  const onChangeContentVariable = (value, status) => {
    switch (status) {
      case "required":
        setTemplate({
          ...template,
          content_variables: {
            ...template.content_variables,
            ContentRequired: value,
          },
        });
        break;
      case "optional":
        setTemplate({
          ...template,
          content_variables: {
            ...template.content_variables,
            ContentOptional: value,
          },
        });
        break;
      default:
        break;
    }
  };

  //Update Template
  async function UpdateTemplateHandler(e) {

    e.preventDefault();

    // The `required` attributes on the inputs below never fire on this screen:
    // the button is a `type="button"` inside a `<Form>` with no `onSubmit`, so
    // no form submission happens and native constraint validation is skipped.
    // An empty name therefore reached the API, which persisted it (SCRUM-1241).
    // The inline "Please insert ..." hints were already rendered; they just did
    // not stop the request.
    const emptyFields = REQUIRED_TEMPLATE_FIELDS.filter(
      (field) => !template[field]
    );

    if (emptyFields.length > 0) {
      NotificationAlertOptions(
        "error",
        "Please fill in all required fields before updating the template."
      );
      return;
    }

    try {
      await dispatch(updateTemplate(template));
      await notify("success", template);
      // Empty settings required + optional in state

      await props.switchToDesignListHandler();
    } catch (err) {
      NotificationAlertOptions(
        "error",
        asCaught(err)?.response?.data?.message || "Updating the template failed. Please try again."
      );
    }

  }

  // Notification
  const notify = (type, template) => {
    NotificationAlertOptions(type, ` ${template.name} updated successfully!`);	
  };

  return (
      <Form>
        <Row>
          {/* START TEMPLATE NAME  */}
          <FormGroup className="col-md-6">
            <Row>
              <Label
                className="form-control-label"
                htmlFor="example-text-input"
                md="2"
              >
                Template Name
              </Label>
              <Col md="10">
                <InputGroup
                  className={classnames("input-group-merge", {
                    focused: template["name"],
                  })}
                >
                  
                    <InputGroupText>
                      <i className="ni ni-badge text-primary" />
                    </InputGroupText>
                  <Input
                    placeholder="Insert Template Name"
                    type="text"
                    value={template["name"]}
                    onChange={onChangeTemplateName}
                    name="name"
                    required
                  />
                </InputGroup>

                {template.name === "" ? (
                  <div className="text-danger">
                    {" "}
                    Please insert template name{" "}
                  </div>
                ) : (
                  // <div className="text-success">Looks good!</div>
                  ""
                )}
              </Col>
            </Row>
          </FormGroup>
          {/* END TEMPLATE NAME  */}

          {/* START TEMPLATE TYPE */}
          <FormGroup className="col-md-6">
            <Row>
              <Label
                className="form-control-label"
                htmlFor="example-text-input"
                md="2"
              >
                Select Template Type
              </Label>
              <Col md="10">
                <Select
                  value={types.filter(
                    (option) => option.value === template["type"]
                  )}
                  name="type"
                  options={types}
                  onChange={onChangeTemplateType}
                  isClearable
                  isSearchable
                  required
                />
                {template.type === "" ? (
                  <div className="text-danger">
                    {" "}
                    Please insert template type{" "}
                  </div>
                ) : (
                  // <div className="text-success">Looks good!</div>
                  ""
                )}
              </Col>
            </Row>
          </FormGroup>
          {/* END TEMPLTATE TYPE  */}

          {/* START TEMPLATE DESIGN  */}

          {/* PS: Since design assigned to a template can't be changed
          there will be no need to get it from state
          or to create an on change method to handle this
          and the input should be disabled */}

          <FormGroup className="col-md-6">
            <Row>
              <Label
                className="form-control-label"
                htmlFor="example-text-input"
                md="2"
              >
                Template Design
              </Label>
              <Col md="10">
                <InputGroup className={classnames("input-group-merge")}>
                  
                    <InputGroupText>
                      <i className="ni ni-palette text-primary" />
                    </InputGroupText>
                  <Input
                    type="text"
                    value={template.design.name}
                    name="design"
                    required
                    disabled={true}
                  />
                </InputGroup>
                <div className="text-orange">
                  {" "}
                  *Note: Template Design can&apos;t be changed
                </div>
              </Col>
            </Row>
          </FormGroup>
          {/* END TEMPLATE DESIGN */}

          {/* START TEMPLATE PATH */}
          <FormGroup className="col-md-6">
            <Row>
              <Label
                className="form-control-label"
                htmlFor="example-text-input"
                md="2"
              >
                Template Source path
              </Label>
              <Col md="10">
                <InputGroup
                  className={classnames("input-group-merge", {
                    focused: template["template_src"],
                  })}
                >
                  
                    <InputGroupText>
                      <i className="ni ni-folder-17 text-primary" />
                    </InputGroupText>
                  <Input
                    placeholder={`Insert Template Path example :  template / ${template["design"].name} / Filename`}
                    type="text"
                    value={template["template_src"]}
                    onChange={onChangeTemplatePath}
                    name="template_src"
                    required
                  />
                </InputGroup>
                {template.template_src === "" ? (
                  <div className="text-danger">
                    {" "}
                    Please insert template Source path{" "}
                  </div>
                ) : (
                  // <div className="text-success">Looks good!</div>
                  ""
                )}
              </Col>
            </Row>
          </FormGroup>
          {/* END TEMPLATE PATH */}
        </Row>

        <>
          {/* START SETTINGS VARIABLES  */}
          <h4 className="mb-0">Design Settings Variables</h4>
          <Row>
            <FormGroup className="col-md-6" style={{ marginTop: "15px" }}>
              <Col md="10">
                {/* DISPLAY SUCCESS OR ERROR MSG ( if  REQUIRED Settings VARIABLE.LENGTH > 0) */}
                <Row>
                  {template.settings_variables.SettingsRequired.length > 0 ? (
                    // <div className="text-success">Looks good!</div>
                    ""
                  ) : (
                    <div className="text-danger">
                      {" "}
                      Please insert template Required Settings{" "}
                    </div>
                  )}
                </Row>
                {/* END MESSAGE */}

                {/* REQUIRED SETTINGS VAR SSSELECTOR */}
                <VariablesSelectByTypes
                  status="required"
                  type="setting"
                  inputLabel="Required"
                  handleVariableChange={onChangeSettignsVariables}
                  dataValue={template.settings_variables.SettingsRequired}
                  show
                ></VariablesSelectByTypes>
                {/* END SELECTOR */}
                <div style={{ marginTop: "20px" }}></div>
                <HandleRequired />
              </Col>
            </FormGroup>
            {/* END SETTINGS REQUIRED VARIABLES */}

            {/* SETTINGS OPTIONAL */}

            <FormGroup className="col-md-6" style={{ marginTop: "15px" }}>
              <Col md="10">
                {/* DISPLAY SUCCESS OR WARINIG MSG ( if  OPTIONAL Settings VARIABLE.LENGTH > 0) */}
                <Row>
                  {template.settings_variables.SettingsOptional.length > 0 ? (
                    // <div className="text-success">Looks good!</div>
                    ""
                  ) : (
                    <div className="text-orange">
                      {" "}
                      No template Optional Settings{" "}
                    </div>
                  )}
                </Row>
                {/* END MESSAGE */}

                {/* OPTIONAL SETTINGS VAR SELECTOR */}
                <VariablesSelectByTypes
                  status="optional"
                  type="setting"
                  inputLabel="Optional"
                  handleVariableChange={onChangeSettignsVariables}
                  dataValue={template.settings_variables.SettingsOptional}
                  show
                ></VariablesSelectByTypes>
                {/* END SELECTOR */}
                <div style={{ marginTop: "20px" }}></div>
                <HandleOptional />
              </Col>
            </FormGroup>
          </Row>

          {/* START CONETNT VARIABLES */}
          <h4 className=" text-center" style={{ margin: "15px" }}>
            Insert Content Variables
          </h4>
          <Row>
            <FormGroup className="col-md-6">
              <Col md="10">
                {/* DISPLAY SUCCESS OR ERROR MSG ( if  REQUIRED CONTENT VARIABLE.LENGTH > 0) */}
                <Row>
                  {template.content_variables.ContentRequired.length > 0 ? (
                    // <div className="text-success">Looks good!</div>
                    ""
                  ) : (
                    <div className="text-danger">
                      {" "}
                      Please insert template Required Content{" "}
                    </div>
                  )}
                </Row>
                {/* END MESSAGE */}
                <VariablesSelectByTypes
                  status="required"
                  type="content"
                  inputLabel="Required"
                  handleVariableChange={onChangeContentVariable}
                  dataValue={template.content_variables.ContentRequired}
                  onReorder={onChangeContentVariable}
                  show
                ></VariablesSelectByTypes>
              </Col>
            </FormGroup>
            <FormGroup className="col-md-6">
              <Col md="10">
                {/* DISPLAY SUCCESS OR WARNING MSG ( if  Optional CONTENT VARIABLE.LENGTH > 0) */}
                <Row>
                  {template.content_variables.ContentOptional.length > 0 ? (
                    // <div className="text-success">Looks good!</div>
                    ""
                  ) : (
                    <div className="text-orange">
                      {" "}
                      No template Optional Content{" "}
                    </div>
                  )}
                </Row>
                {/* END MESSAGE */}
                <VariablesSelectByTypes
                  status="optional"
                  type="content"
                  inputLabel="Optional"
                  handleVariableChange={onChangeContentVariable}
                  dataValue={template.content_variables.ContentOptional}
                  onReorder={onChangeContentVariable}
                  show
                ></VariablesSelectByTypes>
              </Col>
            </FormGroup>
          </Row>

          {/* END CONTENT VARIABLES */}
        </>
        <button
          className="btn btn-outline-primary mr-1 float-right"
          type="button"
          onClick={UpdateTemplateHandler}
        >
          Finish Updating
        </button>
      </Form>
  );
}

export default UpdateTemplate;
